import { Controller } from "stimulus";

const CLASS_WORKING = "is-working";

export default class extends Controller {
    static targets = ["submitButton", "field", "formRow"];

    submit(event) {
        event.preventDefault();

        if (!this.validate()) {
            return;
        }

        this.startWorking();

        this.element.submit();
    }

    validate() {
        let isValid = true;

        for (let row of this.formRowTargets) {
            row.classList.remove("show");
        }

        for (let i = 0; i < this.fieldTargets.length; i++) {
            const field = this.fieldTargets[i];

            if (!field.validity.valid) {
                const row = this.formRowTargets[i];
                row.classList.add("show");

                isValid = false;
            }
        }

        return isValid;
    }

    startWorking() {
        this.submitButtonTarget.disabled = true;
        this.submitButtonTarget.classList.add(CLASS_WORKING);
    }
}



// WEBPACK FOOTER //
// ./public/assets/scripts/controllers/password-form_controller.js